if (typeof window !== 'undefined') {
  function hasNativeScrollEndSupport() {
    const testElement = document.createElement('div');
    let isSupported = false;

    try {
      testElement.addEventListener('scrollend', () => {
        isSupported = true;
      });
    } catch (e) {
      isSupported = false;
    }

    return isSupported;
  }

  if (!hasNativeScrollEndSupport()) {
    const scrollendEvent = new Event('scrollend');
    let isScrolling;

    function onScroll() {
      clearTimeout(isScrolling);
      isScrolling = setTimeout(function () {
        window.dispatchEvent(scrollendEvent);
      }, 350);
    }

    window.addEventListener('scroll', onScroll, false);
  }
}
